import Types from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/enums/types';

export default (context:any, payload:any) => {
    const moduleId = context.getters.moduleId;
    if (context.rootState[`${moduleId}_error-container`].errors.length) {
        return;
    }

    context.commit('appState/SET_VALUE', {
        key: 'isLoading',
        value: true,
    }, {
        root: true,
    });

    setTimeout(() => {
        context.commit('appState/SET_VALUE', {
            key: 'name',
            value: context.rootState[`${moduleId}_name`].value,
        }, {
            root: true,
        });

        const type = context.rootGetters['appState/type'];
        if (type === Types.Job) {
            payload.router.push('/job-report');
        } else if (type === Types.Management) {
            payload.router.push('/management-report');
        } else if (type === Types.Ergonomic) {
            payload.router.push('/ergonomic-evaluation');
        }
    });
};